import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const FaqElement = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <div className="border-bottom faq-element">
      <div
        className="py-4 d-flex align-items-center justify-content-between cursor-pointer faq-question"
        onClick={onClick}
      >
        <div className="font-weight-bold faq-question-text">{question}</div>
        <div className="icon-plus mx-2">
          <img
            srcSet={`
                    https://bottomless.imgix.net/landing-generic-v2/icon-${
                      isOpen ? 'minus' : 'plus'
                    }.png?auto=compress,format&h=24 1x,
                    https://bottomless.imgix.net/landing-generic-v2/icon-${
                      isOpen ? 'minus' : 'plus'
                    }.png?auto=compress,format&h=48 2x
                  `}
            src={`https://bottomless.imgix.net/landing-generic-v2/icon-${
              isOpen ? 'minus' : 'plus'
            }.png?auto=compress,format&h=24`}
            alt="+"
            width="24"
            height="24"
          />
        </div>
      </div>
      <div className={classNames('collapse faq-answer mr-md-5', { show: isOpen })}>
        <p>{answer}</p>
      </div>
    </div>
  );
};

FaqElement.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.node.isRequired,
};
